// RBFJ Theme JS

document.addEventListener('DOMContentLoaded', function () {

  // ── Mobile hamburger menu ──────────────────────────────────
  var hamburger = document.querySelector('.rbfj-hamburger');
  var mobileMenu = document.querySelector('.rbfj-mobile-menu');

  if (hamburger && mobileMenu) {
    hamburger.addEventListener('click', function () {
      var isOpen = mobileMenu.classList.contains('is-open');
      if (isOpen) {
        mobileMenu.classList.remove('is-open');
        hamburger.classList.remove('is-active');
        hamburger.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
      } else {
        mobileMenu.classList.add('is-open');
        hamburger.classList.add('is-active');
        hamburger.setAttribute('aria-expanded', 'true');
        document.body.style.overflow = 'hidden';
      }
    });

    document.addEventListener('click', function (e) {
      if (
        mobileMenu.classList.contains('is-open') &&
        !mobileMenu.contains(e.target) &&
        !hamburger.contains(e.target)
      ) {
        mobileMenu.classList.remove('is-open');
        hamburger.classList.remove('is-active');
        hamburger.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
      }
    });

    window.addEventListener('resize', function () {
      if (window.innerWidth > 1040 && mobileMenu.classList.contains('is-open')) {
        mobileMenu.classList.remove('is-open');
        hamburger.classList.remove('is-active');
        hamburger.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
      }
    });
  }

  // ── Mobile accordion sub-menus ────────────────────────────
  document.querySelectorAll('.rbfj-mobile-dropdown-toggle').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var subMenu = btn.nextElementSibling;
      if (!subMenu) return;
      var isOpen = subMenu.classList.contains('is-open');
      document.querySelectorAll('.rbfj-mobile-sub-menu.is-open').forEach(function (m) {
        m.classList.remove('is-open');
        m.previousElementSibling.classList.remove('is-open');
      });
      if (!isOpen) {
        subMenu.classList.add('is-open');
        btn.classList.add('is-open');
      }
    });
  });

  // ── Contact form tab switcher ──────────────────────────────
  window.rbfjSwitchTab = function (sectionId, tab) {
    var isContact = tab === 'contact';
    var panelContact = document.getElementById('rbfj-panel-contact-' + sectionId);
    var panelBooking = document.getElementById('rbfj-panel-booking-' + sectionId);
    var tabContact = document.getElementById('rbfj-tab-contact-' + sectionId);
    var tabBooking = document.getElementById('rbfj-tab-booking-' + sectionId);
    if (!panelContact) return;
    panelContact.style.display = isContact ? 'block' : 'none';
    panelBooking.style.display = isContact ? 'none' : 'block';
    tabContact.classList.toggle('is-active', isContact);
    tabBooking.classList.toggle('is-active', !isContact);
  };

  // ── Accordion (FAQ / page-accordion) ─────────────────────
  document.querySelectorAll('.rbfj-accordion-trigger').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var body = btn.nextElementSibling;
      if (!body) return;
      var isOpen = body.classList.contains('is-open');
      btn.classList.toggle('is-open', !isOpen);
      body.classList.toggle('is-open', !isOpen);
    });
  });

  // ── Search overlay ────────────────────────────────────────
  var searchTrigger  = document.getElementById('rbfj-search-trigger');
  var searchOverlay  = document.getElementById('rbfj-search-overlay');
  var searchClose    = document.getElementById('rbfj-search-close');
  var searchInput    = document.getElementById('rbfj-search-input');
  var searchResults  = document.getElementById('rbfj-search-results');
  var searchBackdrop = document.getElementById('rbfj-search-backdrop');
  var searchTimer;

  function openSearch() {
    if (!searchOverlay) return;
    searchOverlay.hidden = false;
    searchOverlay.classList.add('is-open');
    searchBackdrop.classList.add('is-open');
    searchTrigger.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    setTimeout(function () { if (searchInput) searchInput.focus(); }, 50);
  }

  function closeSearch() {
    if (!searchOverlay) return;
    searchOverlay.classList.remove('is-open');
    searchBackdrop.classList.remove('is-open');
    searchTrigger.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    setTimeout(function () { searchOverlay.hidden = true; }, 250);
    if (searchResults) searchResults.innerHTML = '';
    if (searchInput) searchInput.value = '';
  }

  if (searchTrigger) {
    searchTrigger.addEventListener('click', function () {
      searchOverlay.hidden ? openSearch() : closeSearch();
    });
  }
  if (searchClose) searchClose.addEventListener('click', closeSearch);
  if (searchBackdrop) searchBackdrop.addEventListener('click', closeSearch);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      if (searchOverlay && !searchOverlay.hidden) closeSearch();
      if (cartDrawer && !cartDrawer.hidden) closeCart();
    }
  });

  var lastSearchQuery = '';

  function renderSearchResults(products, q) {
    if (!searchResults) return;
    var seeAllUrl = '/search?q=' + encodeURIComponent(q) + '&type=product';
    if (!products.length) {
      searchResults.innerHTML = '<p class="rbfj-search-overlay__no-results">No products found.</p>'
        + '<a href="' + seeAllUrl + '" class="rbfj-search-overlay__see-all">Search the full collection &rarr;</a>';
      return;
    }
    var html = products.map(function (p) {
      var imgUrl = p.featured_image && p.featured_image.url ? p.featured_image.url : null;
      var imgAlt = (p.featured_image && p.featured_image.alt) ? p.featured_image.alt : p.title;
      var img = imgUrl
        ? '<img src="' + imgUrl + '" alt="' + escHtml(imgAlt) + '" class="rbfj-search-result__img" loading="lazy">'
        : '<div class="rbfj-search-result__img rbfj-search-result__img--placeholder"></div>';
      // Predictive search returns price as a decimal string in major units ("380.00" = £380),
      // not in pence — so we format directly rather than dividing by 100.
      var rawPrice = p.price_min !== undefined ? p.price_min : p.price;
      var price = rawPrice ? formatSearchPrice(rawPrice) : '';
      return '<a href="' + p.url + '" class="rbfj-search-result" role="option">'
        + img
        + '<div class="rbfj-search-result__info">'
        + '<span class="rbfj-search-result__title">' + escHtml(p.title) + '</span>'
        + (price ? '<span class="rbfj-search-result__price">' + price + '</span>' : '')
        + '</div></a>';
    }).join('');
    html += '<a href="' + seeAllUrl + '" class="rbfj-search-overlay__see-all">See all results for &ldquo;' + escHtml(q) + '&rdquo; &rarr;</a>';
    searchResults.innerHTML = html;
  }

  if (searchInput) {
    searchInput.addEventListener('input', function () {
      var q = searchInput.value.trim();
      lastSearchQuery = q;
      clearTimeout(searchTimer);
      if (q.length < 2) { searchResults.innerHTML = ''; return; }
      searchTimer = setTimeout(function () {
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=10')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            if (lastSearchQuery !== q) return;
            var products = (data.resources && data.resources.results && data.resources.results.products) || [];
            renderSearchResults(products, q);
          })
          .catch(function () { searchResults.innerHTML = ''; });
      }, 250);
    });
  }

  // ── Cart drawer ───────────────────────────────────────────
  var cartTrigger  = document.getElementById('rbfj-cart-trigger');
  var cartDrawer   = document.getElementById('rbfj-cart-drawer');
  var cartClose    = document.getElementById('rbfj-cart-close');
  var cartBackdrop = document.getElementById('rbfj-cart-backdrop');
  var cartBody     = document.getElementById('rbfj-cart-drawer-body');
  var cartFooter   = document.getElementById('rbfj-cart-drawer-footer');
  var cartSubtotal = document.getElementById('rbfj-cart-subtotal');
  var cartBadge    = document.getElementById('rbfj-cart-badge');

  function openCart() {
    if (!cartDrawer) return;
    cartDrawer.hidden = false;
    cartDrawer.classList.add('is-open');
    cartBackdrop.classList.add('is-open');
    cartTrigger.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    fetchCart();
  }

  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    cartBackdrop.classList.remove('is-open');
    cartTrigger.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    setTimeout(function () { cartDrawer.hidden = true; }, 250);
  }

  function fetchCart() {
    if (!cartBody) return;
    cartBody.innerHTML = '<p class="rbfj-cart-drawer__loading">Loading…</p>';
    if (cartFooter) cartFooter.hidden = true;
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(renderCart)
      .catch(function () { cartBody.innerHTML = '<p class="rbfj-cart-drawer__loading">Could not load cart.</p>'; });
  }

  function renderCart(cart) {
    updateCartBadge(cart.item_count);
    if (!cartBody) return;
    if (cart.item_count === 0) {
      cartBody.innerHTML = '<p class="rbfj-cart-drawer__empty">Your cart is empty.</p>';
      if (cartFooter) cartFooter.hidden = true;
      return;
    }
    var html = cart.items.map(function (item) {
      var img = item.image
        ? '<img src="' + item.image + '" alt="' + escHtml(item.title) + '" class="rbfj-cart-drawer__item-img" loading="lazy">'
        : '<div class="rbfj-cart-drawer__item-img rbfj-cart-drawer__item-img--placeholder"></div>';
      var variant = (item.variant_title && item.variant_title !== 'Default Title')
        ? '<span class="rbfj-cart-drawer__item-variant">' + escHtml(item.variant_title) + '</span>'
        : '';
      return '<div class="rbfj-cart-drawer__item">'
        + '<a href="' + item.url + '">' + img + '</a>'
        + '<div class="rbfj-cart-drawer__item-info">'
        + '<a href="' + item.url + '" class="rbfj-cart-drawer__item-title">' + escHtml(item.product_title) + '</a>'
        + variant
        + '<span class="rbfj-cart-drawer__item-price">' + formatMoney(item.final_price) + '</span>'
        + '</div>'
        + '<div class="rbfj-cart-drawer__item-qty">'
        + '<button class="rbfj-qty-btn" data-key="' + item.key + '" data-delta="-1" aria-label="Decrease quantity">−</button>'
        + '<span class="rbfj-qty-val">' + item.quantity + '</span>'
        + '<button class="rbfj-qty-btn" data-key="' + item.key + '" data-delta="1" aria-label="Increase quantity">+</button>'
        + '</div>'
        + '</div>';
    }).join('');
    cartBody.innerHTML = html;

    if (cartSubtotal) cartSubtotal.textContent = formatMoney(cart.total_price);
    if (cartFooter) cartFooter.hidden = false;

    cartBody.querySelectorAll('.rbfj-qty-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key   = btn.dataset.key;
        var delta = parseInt(btn.dataset.delta, 10);
        var qtyEl = btn.parentElement.querySelector('.rbfj-qty-val');
        var qty   = parseInt(qtyEl ? qtyEl.textContent : '1', 10) + delta;
        if (qty < 0) qty = 0;
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: qty })
        })
          .then(function (r) { return r.json(); })
          .then(renderCart)
          .catch(function () {});
      });
    });
  }

  function updateCartBadge(count) {
    if (!cartBadge) return;
    cartBadge.textContent = count;
    cartBadge.style.display = count > 0 ? '' : 'none';
  }

  if (cartTrigger) cartTrigger.addEventListener('click', function () {
    cartDrawer.hidden ? openCart() : closeCart();
  });
  if (cartClose)    cartClose.addEventListener('click', closeCart);
  if (cartBackdrop) cartBackdrop.addEventListener('click', closeCart);

  // Intercept add-to-cart forms to open cart drawer
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (form.id !== 'rbfj-product-form' && !form.classList.contains('rbfj-atc-form')) return;
    e.preventDefault();
    var data = new FormData(form);
    fetch('/cart/add.js', { method: 'POST', body: data })
      .then(function (r) { return r.json(); })
      .then(function () { openCart(); })
      .catch(function () { form.submit(); });
  });

  // ── Helpers ───────────────────────────────────────────────
  function escHtml(str) {
    return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  // For cart/collection prices already in pence (38000 → £380.00)
  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    return '£' + amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  // For predictive search API prices returned as decimal strings in major units ("380.00" → £380.00)
  function formatSearchPrice(val) {
    var n = parseFloat(val);
    if (!n || isNaN(n)) return '';
    return '£' + n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

});
